import React from "react";
import Seo from "../components/seo";
import Layout from "../components/layout";
import SectionHead from "../components/newComponents/sectionHead";
import SocialMediaButtons from "../components/newComponents/socialShare";
import ImgixFilePreview from "../components/newComponents/ImgixFilePreview";
import { getPrettyDate } from "../utils/dates";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { HandleQuery, NewslettersEntryData } from "../queries";

export function NewslettersEntry()
{
    let { slug } = useParams();

    const query_state = useQuery(NewslettersEntryData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data;
    const { entry } = data; 

  const file = entry[0].downloads.length > 0 ? entry[0].downloads[0] : undefined;

  return (
    <Layout>
      <Seo title={entry[0].title} image={ entry[0].featureImage[0]?.url} />
      <div className="main">
        <section className="section-inside" style={{ padding: "0" }}>
          <div className="shell">
            <SectionHead
              heading={entry[0].displayTitle}
              image={entry[0].featureImage[0]}
            />
            <div className="section__inner">
              <aside className="section__aside">

                <ul className="list-info">

                <li>
                    <p className="list__title">
                      <strong>Date</strong>
                    </p>
                    <p className="list__details">
                      {getPrettyDate(entry[0].postDate)}
                    </p>
                  </li>


                  {file && file.title &&
                  <li>
                    <p className="list__title">
                      <strong>File name</strong>
                    </p>
                    <p className="list__details">
                      {file.title}
                    </p>
                  </li>
                  }

                {file && file.kind &&

                  <li>
                    <p className="list__title">
                      <strong>File type</strong>
                    </p>
                    <p className="list__details uppercase">
                      {file.kind}
                    </p>
                  </li>
                }             

                  {file && file.url && <li>
                    <p className="list__title">
                      <strong>Preview</strong>
                    </p>
                    <p className="list__details">
                      <div className="pr-2">
                        <ImgixFilePreview fileUrl={file.url} className="mt-2 border-gray-100 border-solid border aspect-[16/9]" />
                      </div>
                    </p>
                  </li>}
                 
                </ul>             
              </aside>
              <div className="section__content">
                <div dangerouslySetInnerHTML={{ __html: entry[0].summary }} className="mb-2" />
                {entry[0].downloads.length > 0 && <a href={entry[0].downloads[0].url} className="btn btn--green" target="_blank" rel="noreferrer" download>Download</a>}
                {entry[0].newsletterLink && <a href={entry[0].newsletterLink} className="btn btn--green" target="_blank" rel="noreferrer">View newsletter</a>}
                <SocialMediaButtons url={`${entry[0].url}`} title={`${entry[0].title}`} summary={entry[0].summary} twitterVia="GenesisEconomic" linkedInSource="Genesis Analytics"/>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}
